import styled from 'styled-components'

export const Title = styled.h1``

export const SubTitle = styled.span`
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 700;
  font-family: Work Sans;
`

export const SubTitleExtension = styled(SubTitle)`
  font-weight: 400;
  color: #3B3B3B;
`

export const Container = styled.div`
  padding: 0 2rem;
`

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const SecondaryFiltersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const WrapperCheckbox = styled.div`
  display: flex;
  justify-content: inherit;
  align-items: center;
  padding-top: 1.5rem;
`
